var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 16 15",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 14.75c-2.51562 0-4.8125-1.3125-6.07031-3.5-1.257815-2.16016-1.257815-4.8125 0-7 1.25781-2.16016 3.55469-3.5 6.07031-3.5 2.4883 0 4.7852 1.33984 6.043 3.5 1.2578 2.1875 1.2578 4.83984 0 7-1.2578 2.1875-3.5547 3.5-6.043 3.5zm-2.51562-5.08594c-.16407-.1914-.4375-.1914-.62891-.05468-.19141.16406-.19141.43752-.05469.62892.62891.7109 1.66797 1.4492 3.19922 1.4492 1.50391 0 2.543-.7383 3.1719-1.4492.1367-.1914.1367-.46486-.0547-.62892-.1914-.13672-.4649-.13672-.6289.05468-.4649.57424-1.31252 1.14844-2.4883 1.14844-1.20312 0-2.02344-.5742-2.51562-1.14844zm-.54688-3.22656c0 .49219.38281.875.875.875s.875-.38281.875-.875c0-.46484-.38281-.875-.875-.875s-.875.41016-.875.875zm5.25-.875c-.49219 0-.875.41016-.875.875 0 .49219.38281.875.875.875.4922 0 .875-.38281.875-.875 0-.46484-.3828-.875-.875-.875z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.38cca08719a82f320c53f6903c842142.svg";
export { ForwardRef as ReactComponent };